import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, addDoc, query, onSnapshot, where, doc, deleteDoc, updateDoc, increment, serverTimestamp, getDocs, orderBy } from "firebase/firestore";
// Bu yardımcı fonksiyonu en üste ekle

const getStartOfDay = (dateString) => {
  const d = new Date(dateString);
  d.setHours(0, 0, 0, 0);
  return d;
};

const getEndOfDay = (dateString) => {
  const d = new Date(dateString);
  d.setHours(23, 59, 59, 999);
  return d;
};
function SalesPage() {
  // --- MEVCUT STATE'LER ---
  const [bankaAdi, setBankaAdi] = useState('');
  const [cekAdedi, setCekAdedi] = useState(0);
  const [cekler, setCekler] = useState([]); // [{vade: '', tutar: 0}]
  const [birakilanYagLitre, setBirakilanYagLitre] = useState(0);
  const [yagAlimFiyati, setYagAlimFiyati] = useState(250);
  const [islemNotu, setIslemNotu] = useState("");
  const [iadeTipi, setIadeTipi] = useState("NAKİT");
  const [musteriAdi, setMusteriAdi] = useState("");
  const [telefon, setTelefon] = useState("");
  const [bolge, setBolge] = useState("");
  const [kuyruk, setKuyruk] = useState([]);
  const [stoktakiUrunler, setStoktakiUrunler] = useState([]);
  const [gunlukSatislar, setGunlukSatislar] = useState([]);
  const [yazdirilacakFis, setYazdirilacakFis] = useState(null);
  const [yazdirilacakNo, setYazdirilacakNo] = useState("");
  const [yazdirilacakIsim, setYazdirilacakIsim] = useState("");
  const [yazdirilacakTel, setYazdirilacakTel] = useState("");
  const [yazdirilacakBolge, setYazdirilacakBolge] = useState("");
  const [menuGorunur, setMenuGorunur] = useState({ show: false, x: 0, y: 0, targetId: null });
  const [seciliMusteri, setSeciliMusteri] = useState(null);
  const [isSatisModalAcik, setIsSatisModalAcik] = useState(false);
  const [sepet, setSepet] = useState([]);
  const [odemeTipi, setOdemeTipi] = useState("NAKİT");

  // --- YENİ EKLENEN FİLTRE VE MİKTAR STATE'LERİ ---
  const [urunAramaTermi, setUrunAramaTermi] = useState("");
  const [seciliMiktar, setSeciliMiktar] = useState(1);

  // --- FİŞTE SEPETİN GÖZÜKMESİ İÇİN GEREKLİ YEDEK STATE ---
  const [yazdirilacakSepet, setYazdirilacakSepet] = useState([]);

  // --- YENİ EKLENEN RAPOR STATE'LERİ ---
  const [sayfaModu, setSayfaModu] = useState("SATIS"); // "SATIS" veya "RAPOR"
  const [baslangicTarihi, setBaslangicTarihi] = useState(new Date().toISOString().split('T')[0]);
  const [bitisTarihi, setBitisTarihi] = useState(new Date().toISOString().split('T')[0]);
  const [raporVerisi, setRaporVerisi] = useState([]);

  const formatPara = (deger) => {
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(deger);
  };

  useEffect(() => {
    const bugun = new Date(); bugun.setHours(0, 0, 0, 0);
    const qKuyruk = query(collection(db, "kuyruk"), where("tarih", ">=", bugun));
    const unsubKuyruk = onSnapshot(qKuyruk, (snapshot) => {
      const veriler = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setKuyruk(veriler.sort((a, b) => a.siraNo - b.siraNo));
    });

    const qSatislar = query(collection(db, "satislar"), where("tarih", ">=", bugun));
    const unsubSatislar = onSnapshot(qSatislar, (snapshot) => {
      setGunlukSatislar(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    const unsubUrunler = onSnapshot(collection(db, "urunler"), (snapshot) => {
      setStoktakiUrunler(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    return () => { unsubKuyruk(); unsubSatislar(); unsubUrunler(); };
  }, []);

  const raporuGetir = async () => {
    try {
      const bas = getStartOfDay(baslangicTarihi);
      const bit = getEndOfDay(bitisTarihi);

      const q = query(
        collection(db, "satislar"),
        where("tarih", ">=", bas),
        where("tarih", "<=", bit),
        orderBy("tarih", "desc")
      );

      const snap = await getDocs(q);
      const veriler = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setRaporVerisi(veriler);
    } catch (error) {
      console.error("Rapor çekme hatası:", error);
      alert("Rapor getirilirken bir hata oluştu. Firebase indekslerini kontrol edin.");
    }
  };

  const urunGrupla = () => {
    const gruplar = {};
    gunlukSatislar.forEach(satis => {
      satis.urunler.forEach(urun => {
        gruplar[urun.ad] = (gruplar[urun.ad] || 0) + urun.adet;
      });
    });
    return gruplar;
  };

  const toplamCiro = gunlukSatislar.reduce((toplam, s) => toplam + s.toplam, 0);

  // --- GÜNCELLENEN SEPETE EKLE (MİKTAR DESTEKLİ) ---
  const sepeteEkle = (urun) => {
    const adet = Number(seciliMiktar);
    if (adet <= 0) return alert("Geçerli bir miktar girin!");
    if (urun.stok < adet) return alert("Yetersiz stok!");

    const varolan = sepet.find(item => item.id === urun.id);
    if (varolan) {
      setSepet(sepet.map(item => item.id === urun.id ? { ...item, adet: item.adet + adet } : item));
    } else {
      setSepet([...sepet, { ...urun, adet: adet }]);
    }
    setSeciliMiktar(1); // Miktarı sıfırla
    setUrunAramaTermi(""); // Aramayı temizle
  };

  const sepettenCikar = (id) => {
    const varolan = sepet.find(item => item.id === id);
    if (varolan.adet > 1) {
      setSepet(sepet.map(item => item.id === id ? { ...item, adet: item.adet - 1 } : item));
    } else {
      setSepet(sepet.filter(item => item.id !== id));
    }
  };

  const satisModaliAc = async (m) => {
    let oncedenOdenen = 0;

    if (m?.durum === "ODENDI") {
      const onay = window.confirm(`${m.isim} için hesap zaten kapalı. Yeni tartım ekleyip farkı hesaplamak ister misiniz?`);
      if (!onay) return;

      const bugun = new Date(); bugun.setHours(0, 0, 0, 0);
      const qEski = query(collection(db, "satislar"), where("musteriAd", "==", m.isim), where("tarih", ">=", bugun));
      const eskiSnap = await getDocs(qEski);
      eskiSnap.forEach(d => { oncedenOdenen += d.data().toplam; });
    }

    setSeciliMusteri({ ...m, oncedenOdenen });
    setSepet([]);
    setUrunAramaTermi(""); // Arama kutusunu temizle
    setSeciliMiktar(1); // Miktarı 1 yap

    if (m) {
      const bugun = new Date(); bugun.setHours(0, 0, 0, 0);
      const q = query(collection(db, "tartimlar"), where("musteriId", "==", m.id), where("tarih", ">=", bugun));
      const querySnapshot = await getDocs(q);
      let tartimBorcu = 0;
      querySnapshot.forEach((doc) => { tartimBorcu += doc.data().sikimBedeli; });
      if (tartimBorcu > 0) {
        setSepet([{ id: 'sikim-bedeli', ad: 'ZEYTİNYAĞI SIKIM BEDELİ', fiyat: tartimBorcu, adet: 1, isHizmet: true }]);
      }
    }
    setIsSatisModalAcik(true);
  };

  const sepetToplam = sepet.reduce((t, u) => t + (u.fiyat * u.adet), 0);
  // Yağ bırakma seçiliyse tutarı hesapla, değilse 0 say
  const birakilanYagTutari = odemeTipi === "YAG_BIRAKMA"
    ? (Number(birakilanYagLitre) * Number(yagAlimFiyati))
    : 0;

  // Toplam sepet tutarından (ve varsa önceki ödemeden) yağ tutarını düş
  const nihaiBorc = sepetToplam - (seciliMusteri?.oncedenOdenen || 0) - birakilanYagTutari;

  const satisiTamamla = async () => {
    if (sepet.length === 0) return alert("Sepet boş!");

    // Güvenlik kontrolü: Eğer müşteri seçili değilse boş kalmasın
    const finalMusteriAd = seciliMusteri?.isim || "MAĞAZADAN SATIŞ";
    const finalBolge = seciliMusteri?.bolge || "-";
    const finalTelefon = seciliMusteri?.telefon || "-";

    try {
      await addDoc(collection(db, "satislar"), {
        musteriAd: finalMusteriAd, // Artık undefined olma ihtimali yok
        bolge: finalBolge,
        telefon: finalTelefon,
        urunler: sepet,
        toplam: nihaiBorc,
        odemeTipi: nihaiBorc < 0 ? "İADE" : odemeTipi,
        tarih: serverTimestamp(),
        // --- YENİ ALANLAR ---
        birakilanYagLitre: odemeTipi === "YAG_BIRAKMA" ? Number(birakilanYagLitre) : 0,
        yagAlimFiyati: odemeTipi === "YAG_BIRAKMA" ? Number(yagAlimFiyati) : 0,
        islemNotu: islemNotu.toUpperCase()
      });

      // Stok güncelleme işlemleri
      for (const item of sepet) {
        if (!item.isHizmet) {
          await updateDoc(doc(db, "urunler", item.id), {
            stok: increment(-item.adet)
          });
        }
      }

      // Eğer bir kuyruk müşterisi ise durumunu güncelle
      if (seciliMusteri?.id) {
        await updateDoc(doc(db, "kuyruk", seciliMusteri.id), { durum: "ODENDI" });
      }

      // Yazdırma hazırlığı
      setYazdirilacakSepet([...sepet]);
      setYazdirilacakIsim(finalMusteriAd);
      setYazdirilacakTel(finalTelefon);
      setYazdirilacakFis("TAHSILAT");

      setTimeout(() => {
        window.print();
        setIsSatisModalAcik(false);
        setSepet([]);
        setSeciliMusteri(null);
      }, 500);

    } catch (e) {
      console.error("Hata Detayı:", e);
      alert("Hata Mesajı: " + e.message);
    }
  };
  const cekSatirlariniOlustur = (adet) => {
    const sayi = parseInt(adet) || 0;
    setCekAdedi(sayi);
    if (sayi > 0) {
      const birimTutar = Math.abs(nihaiBorc) / sayi;
      const yeniCekler = Array.from({ length: sayi }, () => ({
        vade: new Date().toISOString().split('T')[0],
        tutar: birimTutar.toFixed(2)
      }));
      setCekler(yeniCekler);
    } else {
      setCekler([]);
    }
  };
  const siraFisiYazdir = (no, isim, blg, tel) => {
    const printWindow = window.open('', '_blank', 'width=300,height=600');

    printWindow.document.write(`
    <html>
      <head>
        <style>
          @page { 
            size: 80mm auto; /* Boyu içeriğe göre otomatik ayarlar */
            margin: 0; 
          }
          body { 
            width: 72mm; /* Yazdırılabilir güvenli alan */
            margin: 0; 
            padding: 2mm; 
            font-family: 'Arial', sans-serif; 
            text-align: center;
          }
          .sira-no { 
            font-size: 70px; 
            font-weight: bold; 
            margin: 5px 0;
            line-height: 1;
          }
          .divider { border-top: 1px dashed #000; margin: 5px 0; }
          p { margin: 2px 0; font-size: 14px; font-weight: bold; text-transform: uppercase; }
        </style>
      </head>
      <body>
        <p>AYDIN ZEYTİNYAĞI</p>
        <div class="divider"></div>
        <p style="font-size: 11px;">SIRA NUMARASI</p>
        <div class="sira-no">${no}</div>
        <p>${blg}</p>
        <p>${isim}</p>
        <div class="divider"></div>
        <p style="font-size: 10px;">${new Date().toLocaleString('tr-TR')}</p>
      </body>
    </html>
  `);

    printWindow.document.close();
    printWindow.focus();

    // Önemli: Tarayıcının render etmesi için kısa bir bekleme
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  };

  // --- FİLTRELENMİŞ ÜRÜNLER ---
  const filtrelenmisUrunler = stoktakiUrunler.filter(u =>
    u.ad.toLowerCase().includes(urunAramaTermi.toLowerCase())
  );

  return (
    <div className="flex flex-col gap-4 p-4 bg-slate-950 h-screen max-h-screen overflow-hidden relative text-white" onClick={() => setMenuGorunur({ show: false })}>

      {/* HEADER */}
      <div className="flex items-center justify-between px-2 shrink-0 print:hidden">
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg border border-blue-400">
            <span className="text-white font-black text-[10px] leading-none text-center uppercase tracking-tighter">AYDIN<br />ZEYTİN</span>
          </div>
          <div>
            <h1 className="text-2xl font-black italic tracking-tighter uppercase">
              {sayfaModu === "SATIS" ? "Satış Paneli" : "Mali Raporlar"}
            </h1>
            <p className="text-[10px] font-bold text-slate-500 tracking-widest uppercase">Otomasyon v2.0</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={() => {
              if (sayfaModu === "SATIS") { setSayfaModu("RAPOR"); raporuGetir(); }
              else { setSayfaModu("SATIS"); }
            }}
            className={`px-6 py-3 rounded-xl font-black text-[11px] uppercase transition-all shadow-lg ${sayfaModu === "SATIS" ? 'bg-slate-800 hover:bg-blue-600' : 'bg-blue-600 hover:bg-blue-500'}`}
          >
            {sayfaModu === "SATIS" ? "📊 Kasa Raporları" : "🛒 Satış Ekranına Dön"}
          </button>
          <div className="flex flex-col items-end uppercase">
            <span className="text-emerald-500 text-xs font-black tracking-tighter">● Sistem Aktif</span>
          </div>
        </div>
      </div>

      {sayfaModu === "SATIS" ? (
        <>
          <div className="grid grid-cols-12 gap-4 shrink-0 h-[45%] print:hidden overflow-hidden">
            <div className="col-span-12 md:col-span-4 bg-slate-900 rounded-3xl p-5 border border-slate-800 flex flex-col justify-between">
              <h2 className="text-lg font-black text-blue-500 uppercase mb-4 italic">Müşteri Kaydı</h2>
              <div className="space-y-3 overflow-y-auto pr-2 custom-scrollbar">
                <input value={musteriAdi} onChange={(e) => setMusteriAdi(e.target.value)} placeholder="AD SOYAD" className="w-full bg-slate-800 p-3 rounded-xl outline-none border border-transparent focus:border-blue-600 font-bold uppercase" />
                <input value={telefon} onChange={(e) => setTelefon(e.target.value)} placeholder="TELEFON" className="w-full bg-slate-800 p-3 rounded-xl outline-none border border-slate-700 font-bold" />
                <input value={bolge} onChange={(e) => setBolge(e.target.value)} placeholder="BÖLGE / KÖY" className="w-full bg-slate-800 p-3 rounded-xl outline-none border border-slate-700 font-bold uppercase" />
              </div>
              <div className="mt-4 space-y-2">
                <button onClick={async () => {
                  if (!musteriAdi || !bolge) return alert("Eksik bilgi!");
                  const maxSira = kuyruk.length > 0 ? Math.max(...kuyruk.map(k => Number(k.siraNo) || 0)) : 0;
                  const yeniNo = maxSira + 1;
                  await addDoc(collection(db, "kuyruk"), { isim: musteriAdi.toUpperCase(), telefon, bolge: bolge.toUpperCase(), siraNo: yeniNo, tarih: serverTimestamp(), durum: "BEKLIYOR" });
                  siraFisiYazdir(yeniNo, musteriAdi.toUpperCase(), bolge.toUpperCase(), telefon);
                  setMusteriAdi(""); setTelefon(""); setBolge("");
                }} className="w-full bg-blue-600 hover:bg-blue-500 p-4 rounded-xl text-lg font-black italic transition-all shadow-lg active:scale-95 uppercase">Sıra Ver & Yazdır</button>
                <button onClick={() => satisModaliAc(null)} className="w-full bg-emerald-500/10 text-emerald-500 border border-emerald-500/20 p-2 rounded-lg font-black text-[10px] uppercase">Hızlı Ürün Satışı</button>
              </div>
            </div>

            <div className="col-span-12 md:col-span-8 bg-slate-900/40 rounded-3xl p-5 border border-slate-800 flex flex-col overflow-hidden h-full">
              <div className="flex justify-between items-center mb-4 border-b border-slate-800 pb-2">
                <h2 className="text-slate-500 font-bold uppercase text-[10px] tracking-widest">Bekleyen Müşteri Listesi</h2>
                <span className="bg-blue-600/20 text-blue-500 text-[10px] px-3 py-1 rounded-full font-black uppercase italic">{kuyruk.filter(k => k.durum !== "ODENDI").length} Bekliyor</span>
              </div>
              <div className="grid gap-2 overflow-y-auto pr-2 custom-scrollbar">
                {[...kuyruk].reverse().map((kisi) => {
                  const odendi = kisi.durum === "ODENDI";
                  return (
                    <div key={kisi.id}
                      onContextMenu={(e) => { e.preventDefault(); setMenuGorunur({ show: true, x: e.pageX, y: e.pageY, targetId: kisi.id }); setSeciliMusteri(kisi); }}
                      className={`p-3 rounded-2xl border flex justify-between items-center transition-all ${odendi ? 'bg-slate-950/40 border-slate-900 opacity-30' : 'bg-slate-800/80 border-slate-700 hover:border-blue-500'}`}>
                      <div className="flex items-center gap-4">
                        <div className="w-10 h-10 border-2 border-blue-500/50 flex items-center justify-center rounded-lg bg-blue-500/5 font-black text-blue-500">{kisi.siraNo}</div>
                        <div>
                          <h3 className="font-black uppercase text-sm leading-none">{kisi.isim}</h3>
                          <p className="text-[9px] text-slate-500 font-bold mt-1 uppercase tracking-tighter">{kisi.bolge}</p>
                        </div>
                      </div>
                      <button onClick={() => satisModaliAc(kisi)} className={`px-4 py-2 rounded-xl font-black text-[10px] transition-all uppercase ${odendi ? 'bg-slate-700 text-slate-500' : 'bg-emerald-600 hover:bg-emerald-500 text-white'}`}>
                        {odendi ? "Hesap Kapalı" : "Ödeme Al"}
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="grid grid-cols-12 gap-4 shrink-0 h-[42%] print:hidden overflow-hidden">
            <div className="col-span-12 md:col-span-8 bg-slate-900 rounded-3xl p-5 border border-slate-800 flex flex-col overflow-hidden">
              <h2 className="text-white font-black uppercase text-sm italic mb-3">Günlük Satış Hareketleri</h2>
              <div className="overflow-y-auto custom-scrollbar flex-1 pr-2">
                <table className="w-full text-left text-[11px]">
                  <thead className="text-slate-500 font-bold sticky top-0 bg-slate-900 z-10 border-b border-slate-800 pb-2">
                    <tr><th className="pb-2 uppercase">Müşteri</th><th className="pb-2 uppercase">Detay</th><th className="pb-2 text-right uppercase">Tutar</th></tr>
                  </thead>
                  <tbody className="divide-y divide-slate-800/50">
                    {gunlukSatislar.map((s) => (
                      <tr key={s.id} className="hover:bg-slate-800/30">
                        <td className="py-2 uppercase font-black">{s.musteriAd}</td>
                        <td className="py-2 text-slate-400 font-medium italic">{s.urunler.map(u => `${u.adet}x${u.ad}`).join(", ")}</td>
                        <td className={`py-2 text-right font-black ${s.toplam < 0 ? 'text-orange-500' : 'text-emerald-500'}`}>{formatPara(s.toplam)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="col-span-12 md:col-span-4 flex flex-col gap-4 overflow-hidden">
              <div className="bg-blue-600 rounded-3xl p-5 shadow-xl border border-blue-400 shrink-0">
                <p className="text-white/70 text-[10px] font-bold uppercase tracking-widest">Bugünkü Net Ciro</p>
                <h3 className="text-3xl font-black text-white italic tracking-tighter">{formatPara(toplamCiro)}</h3>
              </div>
              <div className="bg-slate-900 rounded-3xl p-5 border border-slate-800 flex-1 flex flex-col overflow-hidden">
                <h4 className="text-[10px] font-black text-slate-500 uppercase mb-2 border-b border-slate-800 pb-2">Ürün Dağılımı</h4>
                <div className="overflow-y-auto flex-1 custom-scrollbar pr-2">
                  {Object.entries(urunGrupla()).map(([ad, adet]) => (
                    <div key={ad} className="flex justify-between items-center py-2 border-b border-slate-800/40 last:border-0 text-[10px]">
                      <span className="font-bold uppercase text-slate-300">{ad}</span>
                      <span className="font-black text-blue-500">{adet} Adet</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="flex-1 bg-slate-900 rounded-[40px] border border-slate-800 flex flex-col overflow-hidden p-8 animate-in fade-in duration-500">
          <div className="flex flex-col md:flex-row gap-4 mb-8 items-end bg-black/20 p-6 rounded-3xl border border-white/5">
            <div className="flex-1">
              <label className="text-[10px] font-black text-slate-500 uppercase mb-2 block">Başlangıç Tarihi</label>
              <input type="date" value={baslangicTarihi} onChange={(e) => setBaslangicTarihi(e.target.value)} className="w-full bg-slate-800 border border-slate-700 p-3 rounded-xl font-bold outline-none focus:border-blue-500" />
            </div>
            <div className="flex-1">
              <label className="text-[10px] font-black text-slate-500 uppercase mb-2 block">Bitiş Tarihi</label>
              <input type="date" value={bitisTarihi} onChange={(e) => setBitisTarihi(e.target.value)} className="w-full bg-slate-800 border border-slate-700 p-3 rounded-xl font-bold outline-none focus:border-blue-500" />
            </div>
            <button onClick={raporuGetir} className="bg-blue-600 hover:bg-blue-500 px-10 py-3 rounded-xl font-black italic transition-all">SORGULA</button>
          </div>

          <div className="grid grid-cols-4 gap-4 mb-6">
            {[
              { label: "Nakit Toplam", val: raporVerisi.filter(r => r.odemeTipi === "NAKİT").reduce((t, r) => t + r.toplam, 0), color: "text-emerald-500" },
              { label: "Kart Toplam", val: raporVerisi.filter(r => r.odemeTipi === "KART").reduce((t, r) => t + r.toplam, 0), color: "text-blue-500" },
              { label: "Havale Toplam", val: raporVerisi.filter(r => r.odemeTipi === "IBAN").reduce((t, r) => t + r.toplam, 0), color: "text-purple-500" },
              { label: "İadeler", val: raporVerisi.filter(r => r.toplam < 0).reduce((t, r) => t + r.toplam, 0), color: "text-orange-500" }
            ].map(item => (
              <div key={item.label} className="bg-black/30 p-5 rounded-3xl border border-white/5">
                <p className="text-[9px] font-black text-slate-500 uppercase tracking-widest mb-1">{item.label}</p>
                <p className={`text-xl font-black italic ${item.color}`}>{formatPara(item.val)}</p>
              </div>
            ))}
          </div>

          <div className="flex-1 overflow-y-auto custom-scrollbar bg-black/20 rounded-3xl border border-white/5">
            <table className="w-full text-left text-sm">
              <thead className="sticky top-0 bg-slate-800 text-slate-400 font-black uppercase text-[10px]">
                <tr><th className="p-4">Tarih</th><th>Müşteri</th><th>Tip</th><th className="text-right p-4">Tutar</th></tr>
              </thead>
              <tbody className="divide-y divide-white/5">
                {raporVerisi.map(r => (
                  <tr key={r.id} className="hover:bg-white/5 transition-colors">
                    <td className="p-4 text-xs text-slate-500">{r.tarih?.toDate().toLocaleString('tr-TR')}</td>
                    <td className="font-bold uppercase">{r.musteriAd}</td>
                    <td><span className={`px-2 py-1 rounded text-[9px] font-black ${r.toplam < 0 ? 'bg-orange-500' : 'bg-slate-700'}`}>{r.toplam < 0 ? 'İADE' : r.odemeTipi}</span></td>
                    <td className={`text-right p-4 font-black ${r.toplam < 0 ? 'text-orange-500' : 'text-emerald-500'}`}>{formatPara(r.toplam)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-6 flex justify-between items-center bg-blue-600 p-6 rounded-3xl shadow-xl">
            <span className="font-black italic uppercase">Seçili Tarihler Arası Net Kar / Ciro:</span>
            <span className="text-4xl font-black italic tracking-tighter">{formatPara(raporVerisi.reduce((t, r) => t + r.toplam, 0))}</span>
          </div>
        </div>
      )}

      {/* TAHSİLAT MODALI - GÜNCELLENDİ (FİLTRE VE MİKTAR EKLENDİ) */}
      {isSatisModalAcik && (
        <div className="fixed inset-0 bg-black/95 z-[200] flex items-center justify-center p-4">
          <div className="bg-slate-900 border border-slate-700 w-full max-w-6xl h-[85vh] rounded-[40px] flex overflow-hidden shadow-2xl">
            <div className="flex-1 p-8 flex flex-col overflow-hidden">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-emerald-500 font-black uppercase text-xl italic tracking-tighter">Ürün Kataloğu</h2>
                <div className="flex gap-4">
                  <input
                    type="text"
                    placeholder="ÜRÜN ARA..."
                    value={urunAramaTermi}
                    onChange={(e) => setUrunAramaTermi(e.target.value)}
                    className="bg-slate-800 border border-slate-700 p-3 rounded-xl font-black text-xs outline-none focus:border-emerald-500 w-64 uppercase"
                  />
                  <div className="flex items-center gap-2 bg-slate-800 border border-slate-700 p-1 rounded-xl">
                    <span className="text-[10px] font-black text-slate-500 pl-2 uppercase">ADET:</span>
                    <input
                      type="number"
                      min="1"
                      value={seciliMiktar}
                      onChange={(e) => setSeciliMiktar(e.target.value)}
                      className="bg-transparent w-16 p-2 font-black text-emerald-500 outline-none text-center"
                    />
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-3 overflow-y-auto custom-scrollbar pr-2">
                {filtrelenmisUrunler.map(u => (
                  <button key={u.id} onClick={() => sepeteEkle(u)} className="bg-slate-800/50 p-4 rounded-2xl text-left hover:border-emerald-500 border border-transparent transition-all active:scale-95 group relative overflow-hidden">
                    <div className="relative z-10">
                      <p className="font-bold text-[10px] text-slate-400 uppercase group-hover:text-white tracking-widest leading-none">{u.ad}</p>
                      <p className="text-white font-black mt-1 text-lg group-hover:text-emerald-500">{formatPara(u.fiyat)}</p>
                      <p className="text-[9px] text-slate-600 font-bold mt-1 uppercase">Stok: {u.stok} </p>
                    </div>
                    <div className="absolute right-[-10px] bottom-[-10px] text-4xl opacity-5 group-hover:opacity-20 transition-opacity">🛒</div>
                  </button>
                ))}
                {filtrelenmisUrunler.length === 0 && (
                  <div className="col-span-3 text-center py-20 text-slate-600 font-black uppercase italic tracking-widest">Aranan ürün bulunamadı.</div>
                )}
              </div>
            </div>

            <div className="w-[380px] bg-black/40 p-8 flex flex-col justify-between border-l border-slate-800">
              <div className="overflow-y-auto custom-scrollbar flex-1 mb-4 pr-2">
                <h3 className="text-white font-black uppercase text-lg leading-tight mb-2 border-b border-slate-800 pb-2 italic">{seciliMusteri?.isim || "Hızlı Satış"}</h3>

                {seciliMusteri?.oncedenOdenen > 0 && (
                  <div className="bg-blue-500/10 border border-blue-500/20 p-3 rounded-xl mb-4">
                    <p className="text-[9px] font-black text-blue-400 uppercase">Önceki Ödeme</p>
                    <p className="text-white font-black text-lg">{formatPara(seciliMusteri.oncedenOdenen)}</p>
                  </div>
                )}

                <div className="space-y-2">
                  {sepet.map(item => (
                    <div key={item.id} className="flex justify-between items-center text-[11px] bg-slate-800/40 p-3 rounded-xl border border-slate-700/50">
                      <div className="flex flex-col">
                        <span className="font-black uppercase tracking-tighter">{item.ad}</span>
                        <span className="text-[9px] text-slate-500 font-bold uppercase">{item.adet} Adet x {formatPara(item.fiyat)}</span>
                      </div>
                      <div className="flex gap-3 items-center">
                        <span className="font-black text-emerald-500">{formatPara(item.fiyat * item.adet)}</span>
                        <button onClick={() => sepettenCikar(item.id)} className="text-red-500 font-black text-xl hover:scale-125 transition-transform">×</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* ÖDEME VE ALT BÖLÜM */}
              <div className="shrink-0 space-y-3 pt-4 border-t border-slate-800">
                <div className="flex justify-between items-end mb-2">
                  <span className="text-[10px] text-slate-500 uppercase font-bold">{nihaiBorc < 0 ? 'İade Edilecek' : 'Ödenecek Fark'}</span>
                  <span className={`text-3xl font-black italic ${nihaiBorc < 0 ? 'text-orange-500' : 'text-emerald-500'}`}>{formatPara(nihaiBorc)}</span>
                </div>

                {/* İŞLEM NOTU */}
                <input
                  value={islemNotu}
                  onChange={(e) => setIslemNotu(e.target.value)}
                  placeholder="İŞLEM NOTU (ÖRN: YAĞ TAKASI YAPILDI)"
                  className="w-full bg-slate-800 p-3 rounded-xl border border-slate-700 text-[10px] font-bold uppercase outline-none focus:border-slate-500"
                />

                {/* ÖDEME TİPİ VE YAĞ PANELİ - HER DURUMDA GÖRÜNÜR */}
                <div className="space-y-3">
                  {/* Seçim kutusu artık bir şarta bağlı değil, hep görünür */}
                  <select
                    value={odemeTipi}
                    onChange={(e) => setOdemeTipi(e.target.value)}
                    className="w-full bg-slate-800 p-4 rounded-2xl font-black text-xs border border-slate-700 uppercase outline-none focus:border-emerald-500"
                  >
                    <option value="NAKİT">💵 NAKİT</option>
                    <option value="KART">💳 KREDİ KARTI</option>
                    <option value="IBAN">📲 HAVALE / IBAN</option>
                    <option value="YAG_BIRAKMA">🫙 YAĞ BIRAKMA (TAKAS)</option>
                  </select>

                  {/* YAĞ BIRAKMA PANELİ */}
                  {odemeTipi === "YAG_BIRAKMA" && (
                    <div className="space-y-2 mb-2">
                      <div className="grid grid-cols-2 gap-2 p-3 bg-yellow-500/10 border border-yellow-500/20 rounded-2xl">
                        <div>
                          <label className="text-[9px] font-black text-yellow-600 block mb-1 uppercase text-center">KG (LİTRE)</label>
                          <input
                            type="number"
                            value={birakilanYagLitre}
                            onChange={(e) => setBirakilanYagLitre(e.target.value)}
                            className="w-full bg-slate-900 border border-slate-700 p-2 rounded-lg font-black text-white text-center outline-none"
                          />
                        </div>
                        <div>
                          <label className="text-[9px] font-black text-yellow-600 block mb-1 uppercase text-center">BİRİM FİYAT</label>
                          <input
                            type="number"
                            value={yagAlimFiyati}
                            onChange={(e) => setYagAlimFiyati(e.target.value)}
                            className="w-full bg-slate-900 border border-slate-700 p-2 rounded-lg font-black text-white text-center outline-none"
                          />
                        </div>
                      </div>
                      <div className="flex justify-between items-center px-4 py-2 bg-yellow-600/20 rounded-xl border border-yellow-600/30">
                        <span className="text-[10px] font-black text-yellow-500 uppercase">Alınan Yağ Bedeli:</span>
                        <span className="text-sm font-black text-white">{formatPara(Number(birakilanYagLitre) * Number(yagAlimFiyati))}</span>
                      </div>
                    </div>
                  )}

                  {/* SADECE TUTAR EKSİDEYSE İADE TİPİNİ SEÇTİR (YAĞ PANELİNİ KAPATMAZ) */}
                  {/* İADE / CARİ İŞLEM TİPİ SEÇİMİ */}
                  {nihaiBorc < 0 && (
                    <div className="space-y-4 border-t border-slate-700 pt-4 mt-2">
                      <label className="text-[10px] font-black text-orange-500 uppercase block text-center italic">
                        ! İade veya Cari İşlem Seçiniz !
                      </label>

                      <div className="grid grid-cols-2 gap-2">
                        <button onClick={() => setIadeTipi("NAKİT")} className={`p-3 rounded-xl text-[10px] font-black border transition-all ${iadeTipi === "NAKİT" ? 'bg-orange-600 border-orange-400 text-white' : 'bg-slate-800 border-slate-700 text-slate-500'}`}>NAKİT İADE</button>
                        <button onClick={() => setIadeTipi("IBAN")} className={`p-3 rounded-xl text-[10px] font-black border transition-all ${iadeTipi === "IBAN" ? 'bg-orange-600 border-orange-400 text-white' : 'bg-slate-800 border-slate-700 text-slate-500'}`}>IBAN İADE</button>
                        <button onClick={() => setIadeTipi("CEK")} className={`p-3 rounded-xl text-[10px] font-black border transition-all ${iadeTipi === "CEK" ? 'bg-blue-600 border-blue-400 text-white' : 'bg-slate-800 border-slate-700 text-slate-500'}`}>ÇEK İLE ÖDE</button>
                        <button onClick={() => setIadeTipi("BORCA_YAZ")} className={`p-3 rounded-xl text-[10px] font-black border transition-all ${iadeTipi === "BORCA_YAZ" ? 'bg-emerald-600 border-emerald-400 text-white' : 'bg-slate-800 border-slate-700 text-slate-500'}`}>BORCA (CARİYE) YAZ</button>
                      </div>

                      {/* ÇEK GİRİŞ PANELİ (SADECE ÇEK SEÇİLİYSE) */}
                      {iadeTipi === "CEK" && (
                        <div className="p-4 bg-blue-500/10 border border-blue-500/20 rounded-2xl space-y-3 animate-in zoom-in duration-200">
                          <div className="grid grid-cols-2 gap-2">
                            <input
                              placeholder="BANKA ADI"
                              className="bg-slate-900 border border-slate-700 p-2 rounded-lg text-xs font-bold uppercase text-white outline-none focus:border-blue-500"
                              value={bankaAdi}
                              onChange={(e) => setBankaAdi(e.target.value.toUpperCase())}
                            />
                            <input
                              type="number"
                              placeholder="ÇEK ADEDİ"
                              className="bg-slate-900 border border-slate-700 p-2 rounded-lg text-xs font-bold text-white outline-none focus:border-blue-500"
                              onChange={(e) => cekSatirlariniOlustur(e.target.value)}
                            />
                          </div>

                          {cekler.length > 0 && (
                            <div className="max-h-48 overflow-y-auto space-y-2 pr-2 custom-scrollbar">
                              {cekler.map((cek, index) => (
                                <div key={index} className="flex items-center gap-2 bg-slate-800 p-2 rounded-lg border border-slate-700">
                                  <span className="text-[9px] font-black text-blue-400 w-4">{index + 1}.</span>
                                  <input
                                    type="date"
                                    className="bg-transparent text-white text-[10px] font-bold outline-none flex-1"
                                    value={cek.vade}
                                    onChange={(e) => {
                                      const yeni = [...cekler];
                                      yeni[index].vade = e.target.value;
                                      setCekler(yeni);
                                    }}
                                  />
                                  <input
                                    type="number"
                                    className="bg-slate-900 w-24 p-1 rounded text-right text-[10px] font-black text-emerald-400"
                                    value={cek.tutar}
                                    onChange={(e) => {
                                      const yeni = [...cekler];
                                      yeni[index].tutar = e.target.value;
                                      setCekler(yeni);
                                    }}
                                  />
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}

                      {/* BORCA YAZMA BİLGİSİ */}
                      {iadeTipi === "BORCA_YAZ" && (
                        <div className="p-3 bg-emerald-500/10 border border-emerald-500/20 rounded-xl text-center">
                          <p className="text-[10px] font-black text-emerald-500">
                            {formatPara(Math.abs(nihaiBorc))} TUTARI MÜŞTERİNİN HESABINA ALACAK OLARAK KAYDEDİLECEKTİR.
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <button onClick={satisiTamamla} className={`w-full p-5 rounded-2xl font-black text-white text-lg transition-all shadow-lg uppercase active:scale-95 italic ${nihaiBorc < 0 ? 'bg-orange-600 hover:bg-orange-500' : 'bg-emerald-600 hover:bg-emerald-500'}`}>
                  {nihaiBorc < 0 ? 'İadeyi Onayla' : 'Ödemeyi Onayla'}
                </button>
                <button onClick={() => setIsSatisModalAcik(false)} className="w-full text-slate-600 text-[10px] font-bold hover:text-white transition-colors uppercase tracking-widest">Kapat</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* SAĞ TIK MENÜSÜ */}
      {menuGorunur.show && (
        <div className="fixed bg-slate-800 border border-slate-600 shadow-2xl rounded-xl py-1 w-52 z-[300] overflow-hidden" style={{ top: menuGorunur.y, left: menuGorunur.x }}>
          <button className="w-full text-left px-4 py-3 hover:bg-emerald-600 font-bold text-[11px] transition-colors uppercase italic" onClick={() => satisModaliAc(seciliMusteri)}>🛒 Tahsilat Ekranı</button>
          <button className="w-full text-left px-4 py-3 hover:bg-blue-600 font-bold text-[11px] transition-colors uppercase italic" onClick={() => siraFisiYazdir(seciliMusteri.siraNo, seciliMusteri.isim, seciliMusteri.bolge, seciliMusteri.telefon)}>🖨️ Sıra Fişi Yaz</button>
          <div className="h-[1px] bg-slate-700 mx-2 my-1"></div>
          <button className="w-full text-left px-4 py-3 hover:bg-red-600 font-bold text-[11px] transition-colors uppercase italic" onClick={async () => { if (window.confirm("Kayıt silinsin mi?")) await deleteDoc(doc(db, "kuyruk", menuGorunur.targetId)) }}>❌ Kaydı Sil</button>
        </div>
      )}

      <style>{`
        .custom-scrollbar::-webkit-scrollbar { width: 4px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #334155; border-radius: 10px; }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #475569; }
      `}</style>

      {/* --- YAZICI TASARIMI --- */}
      <div id="fis-alani" className="hidden print:block text-black p-4 w-[80mm] font-sans text-center">
        <h1 className="text-xl font-black">AYDIN ZEYTİNYAĞI</h1>
        <div className="border-b-2 border-black my-2"></div>
        {yazdirilacakFis === "SIRA" ? (
          <div>
            <p className="text-[10px] font-bold uppercase">SIRA NUMARASI</p>
            <div className="border-4 border-black inline-block px-8 py-2 my-4 rounded-xl">
              <span className="text-7xl font-black">{yazdirilacakNo}</span>
            </div>
            <h2 className="text-2xl font-black uppercase tracking-tighter">{yazdirilacakIsim}</h2>
            <p className="text-sm font-bold mt-2 uppercase">{yazdirilacakBolge}</p>
            <div className="mt-8 text-[9px] border-t border-black pt-2">{new Date().toLocaleString()}</div>
          </div>
        ) : (
          <div className="text-left text-[11px]">
            <p className="font-black text-center mb-2 border-b-2 border-black pb-1 uppercase">TAHSİLAT MAKBUZU</p>
            <p className="font-bold uppercase">MÜŞTERİ: {yazdirilacakIsim}</p>
            <p className="text-[9px]">TEL: {yazdirilacakTel}</p>

            <div className="border-t border-black mt-2 pt-1 italic">
              {yazdirilacakSepet.map((i, index) => (
                <div key={index} className="flex justify-between border-b border-gray-100 py-1">
                  <span>{i.adet}x {i.ad}</span>
                  <span className="font-bold">{formatPara(i.fiyat * i.adet)}</span>
                </div>
              ))}
            </div>

            <div className="border-t-2 border-black mt-2 pt-2 flex justify-between font-black text-lg uppercase tracking-tighter">
              <span>TOPLAM</span>
              {/* Burayı nihai borç veya sepet toplamına göre revize ettik */}
              <span>{formatPara(yazdirilacakSepet.reduce((t, u) => t + (u.fiyat * u.adet), 0))}</span>
            </div>
            <p className="text-[8px] mt-10 text-center opacity-50 uppercase tracking-widest">Bereketli olsun.</p>
            <div className="text-[8px] text-center mt-2">{new Date().toLocaleString()}</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SalesPage;